module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/surgicals/uarrow-fbe0dcf18a07e3555fe21ea7e764ac80.png";